export class AddDocumentDto {
    name!: string;
    url!: string;
    size!: number;
    mimeType!: string;

    documentTypeId!: string;
    companyId!: string;
}